import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';

// The ArchitectUI shell (.app-main / .app-main__outer) sets position:relative with its own
// z-index, which forms a nested stacking context. Bootstrap's modal-backdrop is appended
// directly to <body>, outside that context — so a modal left nested inside the shell can never
// paint above the backdrop no matter how high the modal's own z-index is set (its stacking is
// capped by its low-z-index ancestor). Moving the modal element itself to be a direct child of
// <body> puts it in the same stacking context as the backdrop, which is what actually fixes it.
@Directive({
  selector: '[appAppendToBody]',
  standalone: true,
})
export class AppendToBodyDirective implements AfterViewInit, OnDestroy {
  constructor(private el: ElementRef<HTMLElement>) {}

  ngAfterViewInit() {
    document.body.appendChild(this.el.nativeElement);
  }

  ngOnDestroy() {
    this.el.nativeElement.remove();
  }
}
